import { Box, Typography, CircularProgress } from "@mui/material";
import { useState, useEffect } from "react";
import { useDispatchApp } from "../../../../lib/redux";
import { startSendMessageChatBot } from "../../../../actions/chat";
import {
  CAMPAIGN_LEARNINGS_TITLE,
  CARD_GET_CAMPAIGN_LEARNINGS_QUESTION,
  OVERVIEW_REPORT_GENERATING_SUMMARY,
} from "../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../lib/i18next";
import {
  getFormattedCampaign,
  getLanguageFormatted,
} from "../../../../utils/string";
import { useFormContext } from "react-hook-form";
import { getFromStatisticsAdsCampaign } from "../../../../services/adsCampaigns";
import i18next from "i18next";
import CampaignLearnings from "../../../../components/Chat/CampaignLearnings";

const CampaignLearningsSection = ({
  onLearningsGenerated = () => {},
  onLearningsFetchSettled = () => {},
}) => {
  const { campaign, reportConfiguration } = useFormContext();
  const { historical } = getFromStatisticsAdsCampaign(campaign);
  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const [learnings, setLearnings] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const onGenerateLearnings = async () => {
    setIsLoading(true);
    try {
      const messages = [
        {
          content: t(CARD_GET_CAMPAIGN_LEARNINGS_QUESTION),
          role: "user",
        },
      ];

      const language = getLanguageFormatted(i18next.language);

      const response = await dispatch(
        startSendMessageChatBot({
          messages,
          chatContext: {
            campaign: getFormattedCampaign({
              data: {
                ...(campaign || {}),
                historicalStatistics: {
                  ...(campaign?.historicalStatistics || {}),
                  historical: historical,
                },
              },
              format: "save",
            }),
            reportConfiguration: {
              startDateTime: reportConfiguration.startDateTime,
              endDateTime: reportConfiguration.endDateTime,
              language,
            },
          },
        })
      );

      if (response && response?.data?.[0]?.learnings) {
        setLearnings(response.data[0].learnings);
        onLearningsGenerated(response.data[0].learnings);
      }
    } catch (error) {
      console.error("Error generating campaign learnings:", error);
    } finally {
      setIsLoading(false);
      onLearningsFetchSettled();
    }
  };

  useEffect(() => {
    onGenerateLearnings();
    // eslint-disable-next-line
  }, []);

  return (
    <Box
      id="campaign-learnings-section"
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: 3,
        pt: 3,
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
        }}
      >
        {t(CAMPAIGN_LEARNINGS_TITLE)}
      </Typography>

      <Box
        sx={{
          width: "100%",
          minHeight: 120,
          display: "flex",
          justifyContent: isLoading ? "center" : "flex-start",
          alignItems: isLoading ? "center" : "flex-start",
        }}
      >
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <CircularProgress size={40} />
            <Typography variant="body2" color="text.secondary">
              {t(OVERVIEW_REPORT_GENERATING_SUMMARY)}
            </Typography>
          </Box>
        ) : learnings.length > 0 ? (
          <CampaignLearnings
            learnings={learnings}
            layout="horizontal"
            hideHeader={true}
          />
        ) : null}
      </Box>
    </Box>
  );
};

export default CampaignLearningsSection;
